import {
  InfiniteEligibility,
  ListInfiniteEligibilitiesResponse,
  listInfiniteEligibilities,
} from '~/services/LuxLoyalty';

export const INFINITE_ELIGIBILITIES_FETCH_PAGE_SIZE = 100;

type ListInfiniteEligibilitiesFilters = {
  email?: string;
  isRetracted?: boolean;
};

export async function collectInfiniteEligibilityPages(
  fetchPage: (page: number, pageSize: number) => Promise<ListInfiniteEligibilitiesResponse>,
  pageSize = INFINITE_ELIGIBILITIES_FETCH_PAGE_SIZE,
): Promise<Array<InfiniteEligibility>> {
  const eligibilities: Array<InfiniteEligibility> = [];
  let page = 1;

  while (true) {
    const response = await fetchPage(page, pageSize);
    const pageRows = response.result.eligibilities ?? [];
    eligibilities.push(...pageRows);

    const pageCount = response.result.pageInfo?.pageCount ?? page;
    const totalRecords = response.result.pageInfo?.totalRecords ?? eligibilities.length;
    if (
      pageRows.length === 0 ||
      pageRows.length < pageSize ||
      page >= pageCount ||
      eligibilities.length >= totalRecords
    ) {
      return eligibilities;
    }

    page += 1;
  }
}

export async function listAllInfiniteEligibilities(
  params: ListInfiniteEligibilitiesFilters = {},
): Promise<Array<InfiniteEligibility>> {
  return collectInfiniteEligibilityPages((page, pageSize) =>
    listInfiniteEligibilities({
      ...params,
      page,
      pageSize,
    }),
  );
}
